export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-1.f78d41a7.png";